import React from 'react';
import PropTypes from 'prop-types';
// Redux
import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
// Stripe
import { ElementsConsumer } from '@stripe/react-stripe-js';
// Components
import PayPal from './Paypal';
import Stripe from './Stripe';

const selector = formValueSelector('PayoutForm');

const PayoutConfirm = ({ previousPage }) => {
  
  const paymentType = useSelector(state => selector(state, 'paymentType'));

  if (paymentType == 2) {
    return (
      <ElementsConsumer>
        {({ stripe, elements }) => (
          <Stripe stripe={stripe} elements={elements} previousPage={previousPage} />
        )}
      </ElementsConsumer>
    );
  }

  return <PayPal previousPage={previousPage} />

}

PayoutConfirm.propTypes = {
  previousPage: PropTypes.any.isRequired,
  paymentType: PropTypes.string.isRequired
};

export default (PayoutConfirm);